import { Badge, Box, Divider, Grid, useColorMode } from "theme-ui";
import BadgeCard from "./BadgeCard";
import { badgesData } from "../../../utils/constent";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getGamificationCriteria, getGamificationCriteriaUser } from "../../../store/actions/Rating.Action";
import { bucketUrl } from "../../../utils/global";
import { useNavigate } from "react-router-dom";


const BadgeDetails: React.FC = () => {
    const dispatch = useDispatch();
    const { gamificationCriteria, loader, earnedBadges } = useSelector((state: any) => state.rating);
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getGamificationCriteria())
        dispatch(getGamificationCriteriaUser())
    }, [])
    type BadgeLevel = "BRONZE" | "SILVER" | "GOLD" | "PLATINUM";

    const blankIcons: Record<Exclude<BadgeLevel, "PLATINUM">, string> = {
        BRONZE: "Gamification/Badges/blankBronze.svg",
        SILVER: "Gamification/Badges/blankSilver.svg",
        GOLD: "Gamification/Badges/blankGold.svg",

    };

    const gamificationCriteriaMap = gamificationCriteria?.data?.reduce((acc: any, item: any) => {
        acc[item.name] = item.icon;
        return acc;
    }, {});

    const groupedEarnedBadges = earnedBadges?.data?.reduce(
        (acc: Record<string, Partial<Record<BadgeLevel, any>>>, badge: any) => {
            const criteriaName = badge.badgeCriteria?.name;
            const badgeLevel: BadgeLevel = badge.badgeId?.name as BadgeLevel;

            if (criteriaName && ["BRONZE", "SILVER", "GOLD", "PLATINUM"].includes(badgeLevel)) {
                if (!acc[criteriaName]) {
                    acc[criteriaName] = { BRONZE: null, SILVER: null, GOLD: null, PLATINUM: null };
                }
                acc[criteriaName][badgeLevel] = {
                    name: badge.badgeId?.name || "",
                    icon: badge.badgeId?.icon ? badge.badgeId.icon.split(".com/")[1] : "",
                    progress: badge.target ? Math.min(Math.round((badge.achived / badge.target) * 100), 100) : 0,

                };
            }

            // Now check badgeHistory to also include previous levels
            if (badge.badgeHistory && Array.isArray(badge.badgeHistory)) {
                badge.badgeHistory.forEach((history: any) => {
                    const historyBadgeLevel: BadgeLevel = history?.badgeId?.name as BadgeLevel;

                    if (["BRONZE", "SILVER", "GOLD"].includes(historyBadgeLevel)) {
                        acc[criteriaName] = acc[criteriaName] || { BRONZE: null, SILVER: null, GOLD: null, PLATINUM: null };
                        acc[criteriaName][historyBadgeLevel] = {
                            name: history?.badgeId?.name || "",
                            icon: history?.badgeId?.icon ? history?.badgeId?.icon.split(".com/")[1] : "",
                            progress: badge.target ? Math.min(Math.round((badge.achived / badge.target) * 100), 100) : 0,
                            // Ensure progress doesn't exceed 100
                        };
                    }
                });
            }

            return acc;
        },
        {}
    );

    const [colorMode] = useColorMode();
    const thColor = colorMode === 'light' ? '#000' : '#ffffff';
    return (
        <div className="main-content px-3">
            <Box className="d-flex justify-content-between align-items-center" sx={{ mb: 4 }}>
                <Box className="d-flex align-items-center px-3">
                    <h2 style={{ color: thColor }}>Badges<Badge className="badge" variant='badgeCount' sx={{ ml: 2, position: 'relative' }}>
                        {gamificationCriteria?.count}
                    </Badge></h2>
                </Box>
            </Box>
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <Grid
                sx={{
                    display: "grid",
                    gap: 3,
                    p: [1, 2, 3, 4, 4],
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr 1fr",
                    ],
                    alignItems: "stretch",
                }}
            >
                {badgesData?.map((badge: any, index: number) => {
                    const earnedBadgesForCriteria = groupedEarnedBadges?.[badge.title] || {
                        BRONZE: null,
                        SILVER: null,
                        GOLD: null,
                        PLATINUM: null
                    };

                    let level;

                    if (earnedBadgesForCriteria?.PLATINUM?.name === 'PLATINUM') {
                        level = " You have Unlocked Secret Badge";
                    } else if (earnedBadgesForCriteria?.GOLD?.name === 'GOLD') {
                        level = "Gold Level";
                    } else if (earnedBadgesForCriteria?.SILVER?.name === 'SILVER') {
                        level = "Silver Level";
                    } else if (earnedBadgesForCriteria?.BRONZE?.name === 'BRONZE') {
                        level = "Bronze Level";
                    }

                    const earnedBadge = earnedBadges?.data?.find((b: any) => b.badgeCriteria?.name === badge.title);
                    const mainIcon = earnedBadge?.badgeCriteria?.icon
                        ? earnedBadge.badgeCriteria.icon
                        : gamificationCriteriaMap?.[badge.title] || badge.badges[0];

                    let hasPlatinum = Boolean(earnedBadgesForCriteria?.PLATINUM);

                    let badgesToDisplay = (hasPlatinum
                        ? ["BRONZE", "SILVER", "GOLD", "PLATINUM"]
                        : ["BRONZE", "SILVER", "GOLD"]
                    ) as any[];

                    badgesToDisplay = badgesToDisplay?.map(category =>
                        earnedBadgesForCriteria?.[category]?.icon
                            ? earnedBadgesForCriteria[category]
                            : { name: `Blank${category}`, icon: blankIcons[category as Exclude<BadgeLevel, "PLATINUM">] || "" }
                    );

                    const progress =
                        earnedBadgesForCriteria?.PLATINUM?.progress ||
                        earnedBadgesForCriteria?.GOLD?.progress ||
                        earnedBadgesForCriteria?.SILVER?.progress ||
                        earnedBadgesForCriteria?.BRONZE?.progress ||
                        0;

                    return (
                        <Box key={index} sx={{ p: 2, display: "flex", alignItems: "stretch", cursor: 'pointer' }} onClick={() => navigate('/my-badges')}>
                            <BadgeCard
                                title={badge?.title}
                                level={level}
                                icon={bucketUrl + mainIcon.split(".com/")[1] || gamificationCriteria?.data?.[index]?.icon}
                                bgBadge={badge.background}
                                badges={badgesToDisplay?.map(b => ({
                                    icon: b.icon,
                                    name: b.name,
                                    progress: b.progress,
                                }))}

                                progress={progress}
                            />
                        </Box>
                    );
                })}
            </Grid>
        </div>
    )
}

export default BadgeDetails